const doc = [({"da":({"js":({"admin":({"tenant_photo_products":({"create_card":({"choose_photo_product":"Vælg fotoprodukt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;